var React = require('react');

function Back (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_44699","data-name":"Group 44699","transform":"translate(-415 -43.001)"},React.createElement("path",{"id":"arrow-left-r","d":"M10.232,4.9,4.55,10.586h15.4v1.364H4.55l5.682,5.682-.964.964L1.939,11.268,9.268,3.939Z","fill":"currentColor","transform":"translate(413.968 41.788)"})));
}

Back.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Back;

Back.default = Back;
